import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const GetSpecificIndirectBeneficiaries = createAsyncThunk(
  "GetSpecificIndirectBeneficiaries/GetSpecificIndirectBeneficiaries",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/IndirectBeneficiaries/GetSpecificIndirectBeneficiaries",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteIndirectBeneficiaries = createAsyncThunk(
  "DeleteIndirectBeneficiaries/DeleteIndirectBeneficiaries",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/IndirectBeneficiaries/DeleteIndirectBeneficiaries",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EditIndirectBeneficiaries = createAsyncThunk(
  "EditIndirectBeneficiaries/EditIndirectBeneficiaries",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/IndirectBeneficiaries/EditIndirectBeneficiaries",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
)
export const AddIndirectBeneficiaries = createAsyncThunk(
  "AddIndirectBeneficiaries/AddIndirectBeneficiaries",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/IndirectBeneficiaries/AddIndirectBeneficiaries",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const IndirectBeneficiaries = createSlice({
  name: "IndirectBeneficiaries",
  initialState: {
    IndirectBeneficiaries: {},
    loadingIndirectBeneficiaries: false,
    errorIndirectBeneficiaries: null,

    UpdateIndirectBeneficiaries: {},
    loadingUpdateIndirectBeneficiaries: false,
    errorUpdateIndirectBeneficiaries: null,

    DeleteIndirectBeneficiaries: {},
    loadingDeleteIndirectBeneficiaries: false,
    errorDeleteIndirectBeneficiaries: null,

    AddIndirectBeneficiaries: {},
    loadingAddIndirectBeneficiaries: false,
    errorAddIndirectBeneficiaries: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetSpecificIndirectBeneficiaries.pending, (state, action) => {
        state.loadingIndirectBeneficiaries = true;
        state.IndirectBeneficiaries = action.payload;
        state.errorIndirectBeneficiaries = null;
      })
      .addCase(GetSpecificIndirectBeneficiaries.fulfilled, (state, action) => {
        state.loadingIndirectBeneficiaries = false;
        state.IndirectBeneficiaries = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificIndirectBeneficiaries.rejected, (state, action) => {
        state.loadingIndirectBeneficiaries = false;
        state.errorIndirectBeneficiaries = action.payload;
      })

      .addCase(DeleteIndirectBeneficiaries.pending, (state, action) => {
        state.loadingDeleteIndirectBeneficiaries = true;
        state.DeleteIndirectBeneficiaries = action.payload;
        state.errorDeleteIndirectBeneficiaries = null;
      })
      .addCase(DeleteIndirectBeneficiaries.fulfilled, (state, action) => {
        state.loadingDeleteIndirectBeneficiaries = false;
        state.IndirectBeneficiaries = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteIndirectBeneficiaries.rejected, (state, action) => {
        state.loadingDeleteIndirectBeneficiaries = false;
        state.errorDeleteIndirectBeneficiaries = action.payload;
      })

      .addCase(EditIndirectBeneficiaries.pending, (state, action) => {
        state.loadingUpdateIndirectBeneficiaries = true;
        state.UpdateIndirectBeneficiaries = action.payload;
        state.errorUpdateIndirectBeneficiaries = null;
      })
      .addCase(EditIndirectBeneficiaries.fulfilled, (state, action) => {
        state.loadingUpdateIndirectBeneficiaries = false;
        state.UpdateIndirectBeneficiaries = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditIndirectBeneficiaries.rejected, (state, action) => {
        state.loadingUpdateIndirectBeneficiaries = false;
        state.errorUpdateIndirectBeneficiaries = action.payload;
      })
      .addCase(AddIndirectBeneficiaries.pending, (state, action) => {
        state.loadingAddIndirectBeneficiaries = true;
        state.AddIndirectBeneficiaries = action.payload;
        state.errorAddIndirectBeneficiaries = null;
      })
      .addCase(AddIndirectBeneficiaries.fulfilled, (state, action) => {
        state.loadingAddIndirectBeneficiaries = false;
        state.AddIndirectBeneficiaries = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddIndirectBeneficiaries.rejected, (state, action) => {
        state.loadingAddIndirectBeneficiaries = false;
        state.errorAddIndirectBeneficiaries = action.payload;
      });
  },
});

export default IndirectBeneficiaries.reducer;
